<template>
<section class="contact">
    <h1> Contact Us </h1>
    <p class="subtitle-center" style="margin-top: 45px;"> Got questions, praise, ideas, <strong>support@coloring-ai.art</strong> is where you can find us
      please don't hesitade to contact us, <br>
      also check out our socials, leave a comment, follow, thank you!</p>
      <div class="social-icons">
        <a href="https://www.facebook.com/profile.php?id=61577953619638" class="social-link facebook" target="_blank" rel="noopener noreferrer"></a>
        <a href="https://www.linkedin.com/company/coloring-ai" class="social-link linkedin" target="_blank" rel="noopener noreferrer"></a>
        <a href="https://www.instagram.com/coloringaiart/" class="social-link instagram" target="_blank" rel="noopener noreferrer"></a>
      </div>
  </section>
</template>


<style scoped>

.contact h1 {
      text-align: center;
      font-size: 2.2rem;
      line-height: 1.1;
      font-weight: 800;
      margin-bottom: -15px;
  }

.subtitle-center {
  color: #64748b;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 auto 1rem auto;
  text-align: center;
}

  /* SOCIALS */

  .social-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.social-link {
  width: 65px;
  height: 65px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  transition: filter 0.3s ease, transform 0.3s ease;
}

.social-link:hover {
  filter: grayscale(0%);
  transform: scale(1.05);
}

/* Icons using Font Awesome or SVG as background */
.social-link.facebook {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg');
  background-color: #42a8b460;
}

.social-link.linkedin {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/linkedin.svg');
  background-color: #6ff18960;
}

.social-link.instagram {
  background-image: url('https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg');
  background-color: #ecec0f60;
}


</style>